"use client";

import React from "react";
import EditSection, {
  TextEditor,
  ListItemEditor,
} from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function HokCategoriesEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <>
          {/* Section Header */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Header</h4>
            <TextEditor
              label="Subtitle"
              value={content.subtitle}
              onChange={(v) => handleChange({ ...content, subtitle: v })}
              placeholder="Categories"
            />
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Browse Popular Categories"
            />
            <TextEditor
              label="Description"
              value={content.text}
              onChange={(v) => handleChange({ ...content, text: v })}
              placeholder="Explore over 8000+ website templates..."
              multiline
            />
            <TextEditor
              label="CTA Button Text"
              value={content.ctaText}
              onChange={(v) => handleChange({ ...content, ctaText: v })}
              placeholder="Explore More"
            />
            <TextEditor
              label="CTA Button Link"
              value={content.ctaUrl || ""}
              onChange={(v) => handleChange({ ...content, ctaUrl: v })}
              placeholder="/categories or https://..."
              multiline
            />
          </div>

          {/* Categories */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Categories</h4>
            <ListItemEditor
              label="Items"
              items={content.categories || [
                { name: "WordPress", count: "15,296", image: "/assets/img/category/category_2_1.png" },
                { name: "Magento", count: "15,296", image: "/assets/img/category/category_2_2.png" },
                { name: "Shopify", count: "15,296", image: "/assets/img/category/category_2_3.png" },
                { name: "Site Templates", count: "15,296", image: "/assets/img/category/category_2_4.png" },
                { name: "WordPress", count: "15,296", image: "/assets/img/category/category_2_1.png" },
                { name: "React Native", count: "15,296", image: "/assets/img/category/category_2_6.png" },
                { name: "Figma Design", count: "15,296", image: "/assets/img/category/category_2_7.png" },
                { name: "WordPress", count: "15,296", image: "/assets/img/category/category_2_1.png" },
              ]}
              itemSchema={[
                { key: "name", label: "Name", type: "text" },
                { key: "count", label: "Count / Number", type: "text" },
                { key: "image", label: "Image / Logo", type: "image" },
              ]}
              onChange={(items) => handleChange({ ...content, categories: items })}
              addItemText="Add Category"
            />
          </div>
        </>
      }
    />
  );
}
